export default __webpack_public_path__ + "static/media/img6.79c4d045.png";